import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import {
  Box,
  Button,
  Flex,
  Select,
} from "@chakra-ui/react";
import Pagination from "../order/components/pagination";
import DataTable from "react-data-table-component";
import Breadcrumb from "../common/breadcrumb";
import navguard from "../auth/navguard";
import Axios from "../../services/axios";
import { useLocation, useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import { DownloadDetail } from "./components/DownloadDetail";
import { resellerLevelList } from "../../constants/helpers/resellerLevelList";
import { capitalize } from "../helpers/string";

const DetailCommunity = () => {
  const [page, setPage] = useState(0);
  const [responseTableCommunity, setResponseTableCommunity] = useState([]);
  const [filterReseller, setFilterReseller] = useState("All");
  const { id } = useParams();
  const changePageHandler = (value) => {
    setPage(value.selected);
  };
  const { search } = useLocation();
  const [totalPage, setTotalPage] = useState(0);

  const fetchDataDetail = async () => {
    try {
      const { data } = await Axios({
        url: `/admin/community/detail/${id}`,
        params: {
          limit: 10,
          page: +page + 1,
          ...(filterReseller !== "All" && { resellerStatus: filterReseller }),
        },
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });

      setTotalPage(data?.data?.totalPage || 1);

      setResponseTableCommunity(
        data?.data?.community?.users?.map(user => ({
          ...user,
          resellerId: user.id || "-",
          resellerName: [user.firstName, user.lastName].filter(Boolean).join(" "),
          levelReseller: user.resellerStatus || "-",
          communityName: data?.data?.community?.name || "-",
        })) || []
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDataDetail();
  }, [id, search, filterReseller, page]);

  const columns = [
    {
      name: (
        <span style={{ color: "#fff" }}>Reseller ID</span>
      ),
      selector: "resellerId",
      cell: (row) => {
        return <span>{row.resellerId}</span>;
      },
      sortable: false,
    },
    {
      name: <span style={{ color: "#fff" }}>Reseller Name</span>,
      cell: (row) => {
        return <span>{row.resellerName}</span>;
      },
      sortable: false,
    },
    {
      name: (
        <div style={{ 
          position: "relative",
          width: "100%",
          color: "#fff"
        }}>
          <div style={{
            position: "absolute",
            left: "-16px",
            top: "-19px",
            bottom: "-20px",
            borderLeft: "1px solid #fff"
          }} />
          Level Reseller
        </div>
      ),
      cell: (row) => {
        return <span>{row.levelReseller}</span>;
      },
      sortable: false,
    },
    {
      name: (
        <div style={{ 
          position: "relative",
          width: "100%",
          color: "#fff"
        }}>
          <div style={{
            position: "absolute",
            left: "-16px",
            top: "-19px",
            bottom: "-20px",
            borderLeft: "1px solid #fff"
          }} />
          Community
        </div>
      ),
      cell: (row) => {
        return <span>{row.communityName}</span>;
      },
      sortable: false,
    },
  ];

  return (
    <>
      <Container fluid={true} style={{ paddingTop: "24px" }}>
        <Card>
          <CardHeader>
            <Breadcrumb isStack title={"Detail Community"} parent={{label: "Community Management", path: "/community/list-community"}} />
            <Flex justifyContent="space-between" alignItems="center">
              <Box>
              <Select
                width="200px"
                value={filterReseller}
                onChange={(event) => {
                  setFilterReseller(event.target.value);
                  setPage(0);
                }}
              >
                <option value="All">All</option>
                {
                  resellerLevelList.map((level) => (
                    <option value={level}>{capitalize(level)}</option>
                  ))
                }
              </Select>
              </Box>
              <DownloadDetail />
            </Flex>
          </CardHeader>
          <CardBody style={{ paddingTop: 0 }}>
            <DataTable
              noHeader={true}
              data={responseTableCommunity}
              columns={columns}
              center={true}
              customStyles={{
                headCells: {
                  style: {
                    backgroundColor: "#ff8084",
                    color: "#fff",
                    fontWeight: "400",
                    fontSize: "14px",
                  },
                },
              }}
            />
            {!isEmpty(responseTableCommunity) && (
              <Box margin={"2rem 0"}>
                <Pagination
                  page={page}
                  totalPage={totalPage}
                  changePageHandler={changePageHandler}
                />
              </Box>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default navguard(DetailCommunity);
